'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _listingModule = require('./listingModule');

var _utils = require('../utils');

var _trackClick = require('../HOCs/trackClick');

var _AnalyticsModule = require('../analytics/modules/AnalyticsModule');

var AnalyticsModule = _interopRequireWildcard(_AnalyticsModule);

var _analytics = require('../constants/analytics');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  overlay: {
    zIndex: '100',
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    position: 'initial',
    width: '600px',
    maxHeight: '80%',
    margin: '75px auto'
  }
};

var DisconnectModal = function DisconnectModal(_ref) {
  var isDisconnectModalOpen = _ref.isDisconnectModalOpen,
      toggle = _ref.toggle,
      modalNames = _ref.modalNames,
      disconnect = _ref.disconnect,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      listingData = _ref.listingData,
      trackButtonClick = _ref.trackButtonClick,
      userId = _ref.userId,
      companyUUID = _ref.companyUUID;

  var toggleThisModal = function toggleThisModal() {
    return toggle(modalNames.disconnect);
  };
  var listingName = void 0;
  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  if (!(0, _utils.canUseDOM)()) {
    return _react2.default.createElement(
      'span',
      null,
      'JavaScript is Required to Disconnect'
    );
  }

  var handleDisconnect = function handleDisconnect(buttonType) {
    if (buttonType === _analytics.button.yes) {
      disconnect(listingId, v1ListingId);
    }
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.disconnect, buttonType],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggleThisModal();
  };

  var trackClicked = function trackClicked(element, additional) {
    return _react2.default.createElement(
      _trackClick.Tracked,
      {
        event: 'CLICK',
        additional: _extends(additional, {
          context: 'LISTING_DETAILS',
          type: 'BUTTON',
          v2_listing_id: listingId,
          app_name: listingName,
          domain: window.location.hostname
        })
      },
      element
    );
  };

  _reactModal2.default.setAppElement('#root');
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactModal2.default,
      {
        style: style,
        isOpen: isDisconnectModalOpen,
        onRequestClose: toggleThisModal,
        contentLabel: 'Disconnect from listing modal'
      },
      _react2.default.createElement(
        'div',
        { className: 'row inside-modal' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-11' },
          _react2.default.createElement(
            'h3',
            null,
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Confirmation' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-1' },
          _react2.default.createElement(
            'span',
            {
              className: 'close-tandc-modal pull-right',
              onClick: toggleThisModal
            },
            '\xD7'
          )
        )
      ),
      _react2.default.createElement('hr', null),
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-1' },
          _react2.default.createElement('span', { className: 'icon-messaging-warning icon-size-lg' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-11', style: { paddingTop: '17px' } },
          _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'DisconnectAreYouSure' })
        )
      ),
      _react2.default.createElement('hr', null),
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          trackClicked(_react2.default.createElement(
            'button',
            {
              style: { minWidth: '110px', marginLeft: '10px' },
              className: 'btn btn-lg btn-default pull-right',
              onClick: function onClick() {
                return handleDisconnect(_analytics.button.yes);
              }
            },
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'Yes' })
          ), { value: 'DISCONNECT_MODAL_YES' }),
          trackClicked(_react2.default.createElement(
            'button',
            {
              style: { minWidth: '110px' },
              className: 'btn btn-lg btn-default cnqr-muted pull-right',
              onClick: function onClick() {
                return handleDisconnect(_analytics.button.no);
              }
            },
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'No' })
          ), { value: 'DISCONNECT_MODAL_NO' })
        )
      )
    )
  );
};

var mapStateToDisconnectProps = function mapStateToDisconnectProps(state) {
  return {
    isDisconnectModalOpen: state.listing.isDisconnectModalOpen,
    listingData: state.listing,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    companyUUID: state.userPrefs.companyUUID
  };
};

DisconnectModal.propTypes = {
  isDisconnectModalOpen: _propTypes2.default.bool.isRequired,
  modalNames: _propTypes2.default.object.isRequired,
  disconnect: _propTypes2.default.func.isRequired,
  toggle: _propTypes2.default.func.isRequired,
  listingId: _propTypes2.default.string,
  v1ListingId: _propTypes2.default.string,
  listingData: _propTypes2.default.object,
  trackButtonClick: _propTypes2.default.func,
  userId: _propTypes2.default.string,
  companyUUID: _propTypes2.default.string
};

exports.default = (0, _reactRedux.connect)(mapStateToDisconnectProps, {
  toggle: _listingModule.toggleModal,
  disconnect: _listingModule.disconnectListing,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})(DisconnectModal);


//////////////////
// WEBPACK FOOTER
// ./lib/listing/DisconnectModal.js
// module id = 593
// module chunks = 0